import auth from '@/axios/auth';

export default {
  getAccessToken(code, redirectUri) {
    const body = {
      code,
      redirectUri,
    };
    return auth.post('/auth/token', body);
  },
  refreshAccessToken(refreshToken) {
    const body = {
      refreshToken,
    };
    return auth.post('/auth/token/refresh', body);
  },
  logout() {
    return auth.get('/auth/logout');
  },
};
